/**
 * @module interface
 */
export interface V2TimGroupMemberOperationResult {
    memberID?: string;
    result?: number;
}
